export default __webpack_public_path__ + "static/media/resubmission-declined.ef6bdd1a.svg";